import { _createSchedulePeriods } from './_createSchedulePeriods';
import _ from 'lodash';

function _updateSchedulingEvents(dailyScheduleForm, dailySchedule) {
  return [...dailySchedule.schedulingEvents].map(schedulingEvent => {
    if (schedulingEvent.code === dailyScheduleForm.code) {
      const { pad } = dailySchedule.padVisit;

      const { endDate } = pad;
      const { startDate, workSchedule, period, workShift, selectionCompleted } = dailyScheduleForm;

      const { periodsForVisit, periodsForRest } = _createSchedulePeriods({
        startDate,
        workScheduleValue: workSchedule,
        workShift,
        endDate,
        period,
        selectionCompleted
      });

      return {
        ...schedulingEvent,
        periodsForRest,
        periodsForVisit,
        formVisits: _.cloneDeep(dailyScheduleForm)
      };
    }

    return schedulingEvent;
  });
}

export { _updateSchedulingEvents };
